import { SET_HIDE_OPTIONS_FOR_INVALID_LINK } from '../../actions/dsr-actions-types'

const INITIAL_STATE_HIDE_EDIT_OPTIONS_INVALID_LINK = { isHideOptionsForInvalidLink: "" }

export function setHideEditOptionsInvalidLinkReducer(state = INITIAL_STATE_HIDE_EDIT_OPTIONS_INVALID_LINK, action) {
    switch (action.type) {
        case SET_HIDE_OPTIONS_FOR_INVALID_LINK:
            return { isHideOptionsForInvalidLink: action.payload };
        default:
            return state;
    }
}